import { isTouchDevice } from '../common/util'
import throttle from 'lodash/throttle'
import { on } from 'delegated-events'
import Swiper, { EffectFade, Mousewheel, Scrollbar, Thumbs } from 'swiper'

Swiper.use([EffectFade, Mousewheel, Scrollbar, Thumbs])

const fn = {
  init: () => {
    const thumbContainer = document.querySelector('.album-thumb-slider .swiper')
    const albumContainer = document.querySelector('.album-slider .swiper')

    const numSlides = albumContainer.querySelectorAll('.swiper-slide').length

    const albumOpts = {
      speed: 300,
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      on: {
        afterInit: fn.setThumbsHeight,
      },
    }

    if (numSlides > 1) {
      const thumbOpts = {
        allowTouchMove: isTouchDevice,
        touchRatio: isTouchDevice ? 1 : 0,
        spaceBetween: 16,
        slidesPerView: 3,
        watchSlidesProgress: true,
        mousewheel: true,
        scrollbar: {
          el: thumbContainer.querySelector('.swiper-scrollbar'),
          hide: false,
        },
        breakpoints: {
          768: {
            direction: 'vertical',
            slidesPerView: 'auto',
          },
        },
      }

      const thumbSlider = new Swiper(thumbContainer, thumbOpts)

      albumOpts.thumbs = {
        swiper: thumbSlider,
      }
    }

    if (numSlides > 1) {
      new Swiper(albumContainer, albumOpts)

      window.addEventListener('resize', throttle(fn.setThumbsHeight, 250))
    }

    on('click', '.photo-caption-toggle', (e) => {
      const caption = e.target.closest('div').querySelector('.photo-caption')

      caption.classList.toggle('is-active')
    })
  },

  setThumbsHeight: () => {
    const thumbContainer = document.querySelector('.album-thumb-slider')
    const albumContainer = document.querySelector('.album-slider')

    if (thumbContainer) {
      thumbContainer.style.setProperty('--sidebar-height', `${albumContainer.offsetHeight}px`)
    }
  },
}

export default {
  can: () => document.body.classList.contains('pagetype-photogallerypage-view'),
  run: fn.init,
}
